import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles((theme: Theme) => {
  const fieldMaxWidth = 220;

  return createStyles({
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column'
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: fieldMaxWidth
    },
    dialogHeaderFooter: {
      background: colors.defaultGrey
    },
    dialog: {
      overflow: 'hidden'
    },
    infoAlert: {
      margin: theme.spacing(1),
      maxWidth: fieldMaxWidth - 20
    },
    infoCardAvatar: {
      background: theme.palette.primary.main
    }
  });
});
